import * as React from 'react'
import { SelectAjaxSeeker } from 'ui-seeker/core'

import { FORM_URL } from 'app/@common/constants'


export default function SelectHotelsUser({ ...props }) {
    const isSingleOption = props.totalOptions === 1

    const myProps = {
        urlAjax: `${FORM_URL.COMPETITION.HOTELS}`,
        label: 'Hotels', placeholder: 'All hotels',
        isClearable: false, firstSelect: false, isMulti: false,
        icon: { icon: 'hotel' },
        extraParams: {
            ...props.userID && { userID: props.userID }
        },
        ...props,
        value: props.value,
        onChange: e => props.onChange(e)
    }

    return <div className={`${props?.className}${isSingleOption ? ' disabled-select' : ''}`}>
        <SelectAjaxSeeker {...myProps} />
        {isSingleOption && <style jsx="true" global="true">{`
            .disabled-select {
                pointer-events: none;
                width: auto;
            }
            /* Aseguramos que la flecha desaparezca */
            .disabled-select [class*="indicatorContainer"] svg,
            .disabled-select [class*="IndicatorContainer"] svg,
            .disabled-select [class*="dropdown-indicator"] {
                display: none !important;
            }
        `}</style>}
    </div>
}